export enum StatusEnum {
  /*
   *
   *  default state, should not appear in nature
   *
   * */
  None = 0,

  /*
   *
   *  there should be at most only one per customer
   *
   * */
  Cart = 10,

  /*
   *
   *  active and pending recurring order
   *
   * */
  Recurring = 20,

  /*
   *
   *  Order has been queued to be charge
   *
   * */
  Charging = 25,

  /*
   *
   *  customer submitted the order, CC charged, but customer may cancel
   *
   * */
  Submitted = 30,

  /*
   *
   *  order is reviewed and packaged, ready to ship, may not be cancelled by customer.
   *
   * */
  Processed = 40,

  /*
   *
   *  the shipment is being processed at a facility
   *
   * */
  PreTransit = 60,

  /*
   *
   *  the shipment is currently en route
   *
   * */
  InTransit = 70,

  /*
   *
   *  the shipment is currently on its last mile and is en route to the destination address
   *
   * */
  OutForDelivery = 80,

  /*
   *
   *  the shipment has been delivered
   *
   * */
  Delivered = 100,

  /*
   *
   *  for recurring order, cancelling just one shipment
   *
   * */
  Skipped = -20,

  /*
   *
   *   order was part of a set of orders that were put on hold (instead of cancelling) by customer
   *
   * */
  Held = -30,

  /*
   *
   *  order is cancelled by customer
   *
   * */
  Cancelled = -40,

  /*
   *
   *  order failed to delivery, or customer did not receive
   *
   * */
  Undelivered = -60,

  /*
   *
   *  no longer valid, mostly due to system error
   *
   * */
  Invalidated = -80,

  /*
   *
   *  order is voided (by admin/staff)
   *
   * */
  Voided = -90,
  Error = -100,
}
